export type AppEnvName =
  | 'REACT_APP_API_HOST'
  | 'REACT_APP_CURRENT_ORIGIN'
  | 'REACT_APP_CURRENT_SERVER'
  | 'REACT_APP_FIRE_BASE_APP_API_KEY'
  | 'REACT_APP_FIRE_BASE_AUTH_DOMAIN'
  | 'REACT_APP_FIRE_BASE_PID'
  | 'REACT_APP_FIRE_BASE_STORAGE_BUCKET'
  | 'REACT_APP_FIRE_MESSAGING_SENDER_ID'
  | 'REACT_APP_FIRE_BASE_APP_ID'
  | 'REACT_APP_FIRE_BASE_MEASURMENT_ID'
  | 'REACT_APP_FIRE_BASE_APP_VAPID_KEY'
  | 'REACT_APP_ENV'
  | 'REACT_APP_GOOGLE_API_KEY';

type RuntimeConfig = Partial<Record<AppEnvName, string>>;

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

// CRA only substitutes explicit process.env.REACT_APP_* references at build time.
// Keep this map explicit so local development continues to use .env.
const buildTimeConfig: RuntimeConfig = {
  REACT_APP_API_HOST: process.env.REACT_APP_API_HOST,
  REACT_APP_CURRENT_ORIGIN: process.env.REACT_APP_CURRENT_ORIGIN,
  REACT_APP_CURRENT_SERVER: process.env.REACT_APP_CURRENT_SERVER,
  REACT_APP_FIRE_BASE_APP_API_KEY:
    process.env.REACT_APP_FIRE_BASE_APP_API_KEY,
  REACT_APP_FIRE_BASE_AUTH_DOMAIN:
    process.env.REACT_APP_FIRE_BASE_AUTH_DOMAIN,
  REACT_APP_FIRE_BASE_PID: process.env.REACT_APP_FIRE_BASE_PID,
  REACT_APP_FIRE_BASE_STORAGE_BUCKET:
    process.env.REACT_APP_FIRE_BASE_STORAGE_BUCKET,
  REACT_APP_FIRE_MESSAGING_SENDER_ID:
    process.env.REACT_APP_FIRE_MESSAGING_SENDER_ID,
  REACT_APP_FIRE_BASE_APP_ID: process.env.REACT_APP_FIRE_BASE_APP_ID,
  REACT_APP_FIRE_BASE_MEASURMENT_ID:
    process.env.REACT_APP_FIRE_BASE_MEASURMENT_ID,
  REACT_APP_FIRE_BASE_APP_VAPID_KEY:
    process.env.REACT_APP_FIRE_BASE_APP_VAPID_KEY,
  REACT_APP_ENV:
    process.env.REACT_APP_ENV,
  REACT_APP_GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
};

export function getAppEnv(name: AppEnvName): string | undefined {
  return window.__RUNTIME_CONFIG__?.[name] || buildTimeConfig[name];
}
